module.exports = __webpack_public_path__ + "media/images/ADC_logo_orange-78e8cdc11a0fe553dbfa7821672a2672.png";